export enum TaskListType {
   AssignedTasks = 1,
   AllTasks = 3
}
